import Filter from 'www/modules/Filters/Filter'

import FilterTypeRegion from 'www/modules/Filters/common/filter-types/FilterTypeRegion'

export default class FilterGroupPlace {
  constructor({ region }) {
    this.region = new Filter(new FilterTypeRegion(region.list), region.initial)
  }

  setFilters({ region }) {
    this.region.setSelectedOptionByValue(region)
  }

  resetFilters() {
    this.region.reset()
  }

  isAnyApplied() {
    return !this.region.isDefault()
  }

  getAppliedNum() {
    if (!this.region.isDefault()) {
      return 1
    }

    return 0
  }

  getFiltersAppliedNames() {
    const res = []

    if (!this.region.isDefault()) {
      res.push(FilterTypeRegion.getAppliedName(this.region))
    }

    return res
  }
}
